import {Redirect, Route, Switch} from "react-router-dom";
import {TitleTab, TitleTabs} from "../../../common/components/TitleTabs.jsx";

import ContentWrapper from "../../../common/components/ContentWrapper.jsx";
import HistoryDocumentsContainer from "../../containers/history/HistoryDocumentsContainer.jsx";
import HistoryTobakContainer from "../../containers/history/HistoryTobakContainer.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import PropTypes from "prop-types";
import React from "react";

export default class HistoryTabsComponent extends React.PureComponent {
    constructor(props) {
        super(props);

        this.extraStyles = {
            display: "flex",
            flexDirection: "column",
            overflowY: "hidden",
        };
    }

    render() {
        const {
            deviceType,
            height,
            localization,
            webEditOnlyTobacco
        } = this.props;

        var dummyclick = () => {};
        const isTinyDevice = deviceType=="xs";

        return (
            <ContentWrapper height={height} paddingRight={true} extraStyles={this.extraStyles}>
                {!isTinyDevice && (
                    <div>
                        <div>
                            { webEditOnlyTobacco ? <TitleTabs><TitleTab onClick={dummyclick} label={localization.text("history", "tobacco")} url={""} deviceType={deviceType} /></TitleTabs> : (
                                <TitleTabs>
                                    
                                    <TitleTab label={localization.text("history", "documents")} url={"/history/documents"} deviceType={deviceType} />
                                    <TitleTab label={localization.text("history", "tobacco")} url={"/history/tobacco"} deviceType={deviceType} />
                                    
                                </TitleTabs>
                            
                            )}
                        </div>
                    </div>
                )}
                <Switch>
                    <Route exact path="/history/documents" component={HistoryDocumentsContainer}/>
                    <Route exact path="/history/tobacco" component={HistoryTobakContainer}/>
                    <Redirect to="/history/documents" push={false}/>
                </Switch>
            </ContentWrapper>
        );
    }
}

HistoryTabsComponent.propTypes = {
    deviceType: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    webEditOnlyTobacco: PropTypes.bool.isRequired,
    localization: Localization.propTypes.isRequired
};